import { render, staticRenderFns } from "./StepForm.vue?vue&type=template&id=147b9e4d&scoped=true&"
import script from "./StepForm.vue?vue&type=script&lang=js&"
export * from "./StepForm.vue?vue&type=script&lang=js&"
import style0 from "./StepForm.vue?vue&type=style&index=0&id=147b9e4d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147b9e4d",
  null
  
)

export default component.exports